module.exports = __webpack_public_path__ + "static/media/2.b72c7579.png";